import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SideMenu, SideMenuChild } from '../../interface/side-menu';
import { OldSideMenu, OldSideMenuChild } from '@app/component/other/header/menu/old-mekanic-menu';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'menuSelected'
})
export class MenuSelectedPipe implements PipeTransform {
  transform(layoutComponent: string, menu: SideMenu | OldSideMenu, expanded: boolean, oldMenu: boolean): boolean {
    const useChildOrChildren = oldMenu ? "child" : "children";
    
    if(!layoutComponent || !menu){
      return false;
    }
    if (layoutComponent === menu.component){
      return true;
    }
    if(menu.shadows && menu.shadows.length && menu.shadows.includes(layoutComponent)){
      return true;
    }
    if (!expanded){
      if (menu[useChildOrChildren] && menu[useChildOrChildren].length){
          if (menu[useChildOrChildren].some((child: SideMenuChild | OldSideMenuChild) => child.component === layoutComponent)){
            return true;
          }
          if(menu[useChildOrChildren].some((child: SideMenuChild | OldSideMenuChild) => child.shadows && child.shadows.length && child.shadows.includes(layoutComponent))){
            return true;
          }
      }
    }
    return false;
  }
}
